export const MBBS_TUITION_FEE_ACADEMIC_YEARS = "2025-2028";

export const MBBS_TUITION_FEE_STRUCTURE = [
  { category: "Government Quota", feePerAnnum: "Rs. 5,40,000" },
  { category: "Management Quota", feePerAnnum: "Rs. 16,20,000" },
  { category: "NRI Quota", feePerAnnum: "Rs. 30,00,000" },
];

export const MBBS_TUITION_FEE_NOTES = [
  "Rs. 60,000 per student is permitted as development fee.",
  "Fees do not include hostel, transport, or mess charges (optional).",
];
